import styled from 'styled-components/macro';

interface SwitchWrapperProps {
  checked?: boolean;
  size?: 'small' | 'default';
}

const sizeValues = {
  width: {
    small: 30,
    default: 47,
  },
  height: {
    small: 18,
    default: 28,
  },
};

export const SwitchWrapper = styled.div<SwitchWrapperProps>`
  width: ${({ size = 'default' }) => `${sizeValues.width[size]}px`};
  max-width: ${({ size = 'default' }) => `${sizeValues.width[size]}px`};
  height: ${({ size = 'default' }) => `${sizeValues.height[size]}px`};
  border-radius: 100px;
  padding: ${({ size = 'default' }) => `${sizeValues.width[size] / 10}px`};
  display: flex;
  cursor: pointer;
  transition: background-color 400ms ease;
  background-color: ${({ checked }) =>
    checked ? 'var(--color-accent-green)' : 'var(--gray-300)'};
  div {
    width: ${({ size = 'default' }) =>
      `${sizeValues.width[size] / 2 - sizeValues.width[size] / 10}px`};
    height: ${({ size = 'default' }) =>
      `${sizeValues.width[size] / 2 - sizeValues.width[size] / 10}px`};
    background-color: #ffffff;
    border-radius: 200px;
    box-shadow: 1px 2px 3px rgba(0, 0, 0, 0.02);
    will-change: trasform;
    transition: transform 400ms ease;
    transform: ${({ size = 'default', checked }) =>
      checked &&
      `translateX(${
        sizeValues.width[size] / 2 - sizeValues.width[size] / 10
      }px)`};
  }
`;
export const SwitchParent = styled.label`
  display: inline-block;
  position: relative;
  input {
    visibility: hidden;
    position: absolute;
  }
`;
